import React, { Component } from 'react'
import RoleControlled from '../../../_common/RoleControlled'
import { deleteMsg } from '../../../../const'

class GuideItem extends Component {
  constructor (props) {
    super(props)

    this.state = {
      edit: false,
      defaultName: this.props.guide.name,
      defaultBody: this.props.guide.body,
      defaultHpUrl: this.props.guide.hp_url,
      defaultVideoUrl: this.props.guide.video_url,
      defaultImageUrl: this.props.guide.image,
      name: this.props.guide.name,
      body: this.props.guide.body,
      hp_url: this.props.guide.hp_url,
      video_url: this.props.guide.video_url,
      image_url: this.props.guide.image,
      img: '',
      image_error: ''
    }
  }

  _handleEditClick () {
    this.setState({ edit: true })
  }
  _handleDeleteClick () {
    console.log('delete info id: ', this.props.guide.id)
    const res = window.confirm(deleteMsg)
    if (res) {
      this.props.deleteData(this.props.guide.id)
    }
  }
  _handleCancelClick () {
    this.setState({
      edit: false,
      name: this.state.defaultName,
      body: this.state.defaultContent,
      hp_url: this.state.defaultHpUrl,
      video_url: this.state.defaultVideoUrl,
      image_url: this.state.defaultImageUrl,
      img: '',
      image_error: ''
    })
  }
  _handleSaveClick () {
    console.log('saving data...')
    const {
      name,
      body,
      hp_url,
      video_url,
      image
    } = this.state
    const data = {
      guide_id: this.props.guide.id,
      guide_category_id: this.props.categoryID,
      name,
      body,
      hp_url,
      video_url
    }
    this.props.saveData(data, image)
    this.setState({ edit: false })
  }

  async _handleImageChange (e) {
    const image = e.target.files[0]
    if (image) {
      if (
        (image.type === 'image/png' || image.type === 'image/jpeg' || image.type === 'image/jpeg') &&
        (image.name.indexOf('png') > 0 || image.name.indexOf('jpeg') > 0 || image.name.indexOf('jpg') > 0)
      ) {
        let reader = new FileReader()
        reader.onload = (e) => {
          this.setState({image_url: e.target.result})
        }
        reader.readAsDataURL(e.target.files[0])
        this.setState({ image })
      } else {
        this.setState({ image_error: '画像ファイル外を選択しました。\n確認の上でもう一度画像ファイルを選択してください。' })
      }
    }
  }

  _handleUpdateContent (key, e) {
    this.setState({ [key]: e.target.value })
  }

  _resetImage () {
    this.setState({ image: '', image_url: '' })
    document.getElementById(`image_${this.props.guide.id}`).value = ''
  }

  _renderImageLabel () {
    if (this.state.edit) {
      if (this.state.image_url) {
        return (
          <div className="label_container">
            <label className="image_input_label image_selected" htmlFor={`image_${this.props.guide.id}`}>
              <img className="img-responsive" src={this.state.image_url} alt=""/>
            </label>
            <div className="delete_container" onClick={this._resetImage.bind(this)}>
              <span></span>
              <span></span>
            </div>
          </div>
        )
      }
      return (
        <div className="label_container">
          <label className="image_input_label image_blank" htmlFor={`image_${this.props.guide.id}`}>
            <svg className="add" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" >
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="16"></line>
              <line x1="8" y1="12" x2="16" y2="12"></line>
            </svg>
          </label>
        </div>
      )
    }
    return (
      <div className="label_container">
        <div className="image_input_label image_selected show" htmlFor={`image_${this.props.guide.id}`}>
          <img className="img-responsive" src={this.state.image_url} alt=""/>
        </div>
      </div>
    )
  }

  _renderRightBlock () {
    if (this.state.edit) {
      return (
        <div className="right_block">
          <div className="input_group">
            <label htmlFor="name">件名</label>
            <input type="text" value={ this.state.name } onChange={ this._handleUpdateContent.bind(this, 'name') }/>
          </div>
          <div className="input_group">
            <label htmlFor="content">本文</label>
            <textarea rows="10" type="text" value={ this.state.body } onChange={ this._handleUpdateContent.bind(this, 'body') }></textarea>
          </div>
          <div className="input_group">
            <label htmlFor="hp_url">外部リンク</label>
            <input type="url" value={ this.state.hp_url } onChange={ this._handleUpdateContent.bind(this, 'hp_url') }/>
          </div>
          <div className="input_group">
            <label htmlFor="video_url">動画リンク</label>
            <input type="url" value={ this.state.video_url } onChange={ this._handleUpdateContent.bind(this, 'video_url') }/>
          </div>
        </div>
      )
    }
    return (
      <div className="right_block">
        <div className="input_group">
          <label htmlFor="name">件名</label>
          <div className="value bold" >{ this.state.name }</div>
        </div>
        <div className="input_group">
          <label htmlFor="tel">本文</label>
          <div className="value" >{ this.state.body }</div>
        </div>
        <div className="input_group link">
          <label htmlFor="open">外部リンク</label>
          <a className="value" target="_blank" href={ this.state.hp_url } >{ this.state.hp_url }</a>
        </div>
        <div className="input_group link">
          <label htmlFor="open">動画リンク</label>
          <a className="value" target="_blank" href={ this.state.video_url } >{ this.state.video_url }</a>
        </div>

      </div>
    )
  }

  _renderBtns () {
    if (this.state.edit) {
      return [
        <button key="cancel" className="btn reverse_red" onClick={this._handleCancelClick.bind(this)}>キャンセル</button>,
        <button key="save" className="btn reverse_primary" onClick={this._handleSaveClick.bind(this)}>保存</button>
      ]
    }
    return [
      <button key="delete" className="btn red" onClick={this._handleDeleteClick.bind(this)}>削除</button>,
      <button key="edit" className="btn reverse_primary" onClick={this._handleEditClick.bind(this)}>編集</button>
    ]
  }

  render () {
    return (
      <article className="guide">
        <div className="info_inner admin_inner flex justify-between">
          <div className="input-group flex column">
            <label className="label text-center" htmlFor="image">
              {
                this.state.edit
                  ? <span className="smallest file_requirements">（JPEG・PNGファイルのみ）</span>
                  : null
              }

            </label>
            <div className="image_input_container flex">
              { this._renderImageLabel() }
              <div>
                <div className="image_error small">{ this.state.image_error }</div>
                <input
                  type="file"
                  id={`image_${this.props.guide.id}`}
                  onChange={this._handleImageChange.bind(this)}
                />
              </div>
            </div>
          </div>

          <div className="contents flex top_label">
            { this._renderRightBlock()}
          </div>
        </div>
        <RoleControlled role={this.props.role} acceptedRoles={[0, 1]}>
          <div className="btn_group flex">
            { this._renderBtns() }
          </div>
        </RoleControlled>

      </article>
    )
  }
}

export default GuideItem



// WEBPACK FOOTER //
// ./src/components/Properties/Guides/Guide/GuideItem.js